import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m2.3 6.8 5.2-5.1v11.7c0 .3.2.5.5.5s.5-.2.5-.5V1.7l5.1 5.1c.2.2.5.2.7 0s.2-.5 0-.7L8.7.5c-.4-.4-1-.4-1.4 0L1.6 6.2c-.2.2-.2.5 0 .7s.6.1.7-.1M14 15H2c-.3 0-.5.2-.5.5s.2.5.5.5h12c.3 0 .5-.2.5-.5s-.2-.5-.5-.5" />
  </svg>
);
const SvgContainerArrowUp = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="container-arrow-up" {...props} />;
export default SvgContainerArrowUp;
